/**
 * Для каждой карточки товара добавляется свой dropdown, который появляется при наведении на эту карточку.
 * Компонент dropdown создается и рендерится с помощью Vue.extend. Если dropdown создается внутри комплексного виджета, то
 * он добавляется в блок l-ss-c-search-results-wrapper. Если dropdown создается внутри попапа, то он добавляется в
 * блок l-ss-c-root.
 */

import Vue from 'vue';
import OfferDropdown from '@/core/components/offer/offer-dropdown/offer-dropdown.js';

const offersDropdown = {};

export default function offerDropdownCustomResolver({ root, firstOfferId, prepareItem, prepareItems, item, i }) {
    if (!offersDropdown[firstOfferId]) {
        const isComplexWidget = root.$el.classList.contains('l-ss-c-root');

        const rootEl = !isComplexWidget ?
            root.$el.querySelector('.l-ss-c-root') :
            root.$el.querySelector('.l-ss-c-search-results-wrapper');

        const dropdownData = prepareItem(item, i, { root: rootEl });
        const child = prepareItems(item.child);

        const DropdownConstructor = Vue.extend({
            extends: OfferDropdown,
            props: dropdownData.bind,
            data: function () {
                return {
                    child,
                };
            },
        });

        const instance = new DropdownConstructor();

        const onDestroy = () => {
            instance.$destroy(true);
            delete offersDropdown[firstOfferId];
        };

        instance.$mount();

        offersDropdown[firstOfferId] = instance;

        rootEl.appendChild(instance.$el);

        return {
            onDestroy,
        };
    } else {
        const dropdownInstance = offersDropdown[firstOfferId];
        dropdownInstance.child = prepareItems(item.child);
    }
}
